export enum FilterTypes {
  All = 'All',
  Active = 'Active',
  Completed = 'Completed',
}
